import React from 'react';
import { UI_CONSTANTS, BadgeVariant } from '../../constants/ui';

interface StatusBadgeProps {
  status: string;
  variant?: BadgeVariant;
  className?: string;
}

const getVariantClasses = (variant: BadgeVariant): string => {
  const colors = UI_CONSTANTS.COLORS;
  
  switch (variant) {
    case 'emerald':
      return colors.emerald.badge;
    case 'amber':
      return colors.amber.badge;
    case 'red':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300';
    case 'slate':
    default:
      return 'bg-slate-100 text-slate-800 dark:bg-slate-900/20 dark:text-slate-300';
  }
};

export const StatusBadge: React.FC<StatusBadgeProps> = React.memo(({
  status,
  variant = 'slate',
  className = ''
}) => {
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getVariantClasses(variant)} ${className}`}>
      {status}
    </span>
  );
});
StatusBadge.displayName = 'StatusBadge';

export default StatusBadge;